/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import { Navigate } from 'react-router-dom';
import Settings from "./Settings";
import Account from "./tabs/Account";
import Security from "./tabs/Security";

const SettingsConfig = {
  routes: [
    {
      path: "settings",
      element: <Settings />,
      children: [
        {
          path: "account",
          element: <Account />,
        },
        {
          path: "security",
          element: <Security />,
        },
        {
          path: '',
          element: <Navigate to="account" />
        }
      ],
    },
  ],
};

export default SettingsConfig;
